import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialog } from '@angular/material/dialog';

import { Subscription } from 'rxjs';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { StandingsDialogComponent } from './standings.dialog.component';
import { DataService } from '@services/data.service';

@Component({
  selector: 'cashout-component',
  templateUrl: '../sharedTemplates/cashout.component.html',
})
export class CashoutComponent implements AfterViewInit, OnDestroy {
  isMobileView = false;

  constructor(
    private _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper,
    private _DataService: DataService,
    public dialog: MatDialog,
    private _webWorkerService: WebWorkerService
  ) {
    this._UiHelper.currentSlipHeaderTabSelectedListener.subscribe(tab => {
      // if (this.isMobileView === false && tab === 2) {
      //   this._DataService.fireApiCall('getSlipCashOutValues');
      // }
    });

    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w <= 990) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });
  }

  @Output() cashoutLengthListener: EventEmitter<any> = new EventEmitter();
  isLive = false;
  _CASHOUTDELAYTIME = 8000;

  cashoutSlipsList = [];
  cashoutSlipsControlList = [];

  cashoutSlipDetailList = [];
  cashOutValue = 0;
  cashoutIsActive = false;
  today = new Date();

  cashoutApproveSlipId = 0;
  cashoutSubmitMessageIsActive = false;

  private subscriptionsToStopOnDestroy: Subscription[] = [];

  oldCashoutSlipsList;

  lastSlipId;

  source;
  cashoutWatch;

  ngAfterViewInit() {
    this._DataService.activeList.getSlipCashOutValues = true;
    if (this.isMobileView) {
      if (this._UserHelper.isSignedIn) {
        this._DataService.removeDataGetter('getSlipCashOutList');
        this._DataService.setDataGetter('getSlipCashOutList', 15);
      }
      {
        this.subscriptionsToStopOnDestroy.push(
          this._UserHelper.signInListener.subscribe(s => {
            if (s === true) {
              this._DataService.setDataGetter('getSlipCashOutList', 15);
            } else {
              this._DataService.removeDataGetter('getSlipCashOutList');
              this._DataService.removeDataGetter('getSlipCashOutValues');
            }
          })
        );
      }
    } else {
      if (this._UserHelper.isSignedIn) {
        this._DataService.setDataGetter('getSlipCashOutList', 15);
      } else {
        this._UiHelper.b3000SetRightMenuState('open');
        this.subscriptionsToStopOnDestroy.push(
          this._UserHelper.signInListener.subscribe(s => {
            if (s === true) {
              this._DataService.setDataGetter('getSlipCashOutList', 15);
            } else {
              this._DataService.removeDataGetter('getSlipCashOutList');
              this._DataService.removeDataGetter('getSlipCashOutValues');
            }
          })
        );
      }
    }

    this._UiHelper.setNavbarTitle('Cashout', true);
  }

  private mergeCashoutValues = e => {
    const cList = e.cList;
    const oldList = e.oldList;

    cList.map(x => {
      if (oldList != undefined) {
        const cv = oldList.filter(ocv => ocv.SlipId == x.SlipId);
        if (cv != undefined && cv.length > 0 && x != undefined) {
          x.CashoutValue = cv[0].CashoutValue;
          x.isLive = cv[0].isLive;
          x['details'] = cv[0]['details'];
          x.State = 0;
        }
      } else {
        x.cashoutSubmitMessageIsActive = false;
      }
      return x;
    });

    return cList;
  };

  getCashoutSlipDetail(slipId) {
    this._ApiService.getCashoutValueExternal(slipId).then(cashoutValue => {
      if (cashoutValue == undefined) {
        return;
      }
      if (cashoutValue == '') {
        return;
      }

      this.cashoutSlipDetailList = cashoutValue;
      if (cashoutValue != '' && this.cashoutSlipDetailList.length != 0) {
        if (cashoutValue[0] != undefined) {
          if (cashoutValue[0] != undefined) {
            this.cashOutValue = cashoutValue[0].CashOutValue;
          }
        }
      }
    });
  }

  getCashoutValue() {
    this._DataService.setDataGetter('getSlipCashOutValues', 10);
    // todo don't working
    this.oldCashoutSlipsList = this._DataHelper.cashoutSlipsList;
  }

  cashoutApprove(id) {
    this.cashoutApproveSlipId = id;
  }

  cashoutModify() {
    this.cashoutApproveSlipId = 0;
  }

  cashOut(slipId, cashOutValue) {
    const cv = this._DataHelper.cashoutSlipsList.filter(ocv => ocv.SlipId == slipId);

    const currentCashoutSlip = this._DataHelper.cashoutSlipsList.find(i => i.SlipId === slipId);
    const isLiveMatch = currentCashoutSlip.isLive;
    if (cv != undefined && cv.length > 0) {
      cv[0].cashoutSubmitMessageIsActive = true;
    }
    this._UiHelper.setLoadingDialog(true);
    const translator = new TranslatePipe(this._LocalizationService);

    setTimeout(
      () => {
        this._ApiService.cashOutPay(slipId, cashOutValue).then(result => {
          ////// console.log("X", result);
          const cv = this._DataHelper.cashoutSlipsList.filter(ocv => ocv.SlipId == slipId);
          if (cv != undefined && cv.length > 0) {
            cv[0].cashoutSubmitMessageIsActive = false;
          }
          this._UiHelper.setLoadingDialog(false);
          if (result.code == 'error') {
            this._UiHelper.errorSnackBar(result.message, '');
          } else if (result.code == 'errorcode') {
            const t_message = translator.transform(result.message, null);
            this._UiHelper.errorSnackBar(t_message, '');
          } else if (result.code == 'success') {
            const t_message = translator.transform('cashoutsuccess', null);
            this._UiHelper.successSnackBar(t_message, '');
            this._DataService.fireApiCall('getSlipCashOutList');
            this._ApiService.getClient().then(u => {
              this._UserHelper.setUser(u);
            });
            // this._router.navigate(['/home']);
          }
        });
      },
      isLiveMatch ? 8 * 1000 : 0
    );
  }

  ngOnDestroy() {
    if (this.cashoutWatch != undefined) {
      this.cashoutWatch.unsubscribe();
      this.cashoutWatch = null;
      this.source = null;
    }
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }

    this._DataService.activeList.getSlipCashOutValues = false;
  }

  cashoutButtonActive(status) {
    this.cashoutIsActive = status;
  }

  Cashout_ExpansionPanel_Close(id = 0) {
    if (id == this.lastSlipId) {
      this.lastSlipId = 0;
    }
    this.cashoutButtonActive(false);
  }

  Cashout_ExpansionPanel_Open(id = 0) {
    this.cashoutSlipDetailList = [];
    this.lastSlipId = id;
  }

  goLiveEventDetail(e) {
    this._router.navigate(['/liveeventdetail', e]);
  }

  goEventDetail(e) {
    this._router.navigate(['/eventdetail', e]);
  }

  getLiveEvent(e) {
    ////// console.log("E", e);
    ////// console.log("this._DataHelper.liveData", this._DataHelper.liveData);

    if (this._DataHelper.liveData != undefined) {
      const match = this._DataHelper.liveData.find(m => m.BetradarMatchId == e);
      ////// console.log("LIVE", match + " "+ e);
      return match;
    }
  }

  // bet3000
  OpenAccountMobile(selectMenu, selectedSlip) {
    this._UiHelper.b3000SetAcountMobileState('open', selectMenu, selectedSlip);
  }

  goDetail(selectedEvent) {
    const translator = new TranslatePipe(this._LocalizationService);

    if (selectedEvent.IsLive == true) {
      if (selectedEvent.MatchStatus == 'Ende') {
        this.openStatsDialog(selectedEvent.BetradarMatchId);
        return;
      }

      this._DataHelper.selectedMatch = { GroupName: '', IsoName: '' };
      this._DataHelper.selectedMatch.GroupName = translator.transform('MyBets', null);
      this._DataHelper.selectedMatch.IsoName = '';
      this.goLiveEventDetail(selectedEvent.EventId);
    } else {
      if (selectedEvent.MatchStatus == 'Ende') {
        this.openStatsDialog(selectedEvent.BetradarMatchId);
        return;
      }

      if (selectedEvent != undefined && selectedEvent.MatchStatus == '' && selectedEvent.State != '') {
        this.openStatsDialog(selectedEvent.BetradarMatchId);
        return;
      }

      this._DataHelper.selectedMatch = { TournamentName: '', IsoName: '' };

      this._DataHelper.selectedMatch.TournamentName = translator.transform('MyBets', null);

      this._DataHelper.selectedMatch.IsoName = '';

      this.goEventDetail(selectedEvent.EventId);
    }
  }

  // Biten Maçlar için Sportradar Modal açıyor
  openStatsDialog(betradarMatchId) {
    const dialogRef = this.dialog.open(StandingsDialogComponent, {
      id: 'standingsDialog',
      panelClass: 'standingsDialogClass',
      height: '90%',
      width: '90%',
      data: {
        tournamentId: '',
        sportId: '',
        betradarMatchId: betradarMatchId,
        type: 'endedmatchresult',
      },
    });
  }
  cashoutInfo() {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService
      .cashoutInfo()
      .then(result => {
        if (result.ResultCode == 1) {
          this._ApiService.getClient2().then().catch();
        } else {
          const translator = new TranslatePipe(this._LocalizationService);
          const t_message_err = translator.transform('errorcode3', null);
          this._UiHelper.errorSnackBar(t_message_err, '');
        }
      })
      .finally(() => {
        this._UiHelper.setLoadingDialog(false);
      });
  }
  trackBySlipId(index: number, item: any) {
    return item.SlipId;
  }
}
